module.exports = __webpack_public_path__ + "static/img/1808_8.dfa0acb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_8.jpg
// module id = RU3D
// module chunks = 1